import { render, staticRenderFns } from "./PaperForm.vue?vue&type=template&id=1868f7fd&scoped=true"
import script from "./PaperForm.vue?vue&type=script&lang=js"
export * from "./PaperForm.vue?vue&type=script&lang=js"
import style0 from "./PaperForm.vue?vue&type=style&index=0&id=1868f7fd&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1868f7fd",
  null
  
)

export default component.exports